enum SortOption {
  FreeShipping = 'FreeShipping',
  MostPopular = 'MostPopular',
  GreatDeal = 'GreatDeal',
  AcquisitionTime = 'AcquisitionTime',
  NewestInventory = 'NewestInventory',
  HighestPrice = 'HighestPrice',
  LowestPrice = 'LowestPrice',
  MakeAndModel = 'MakeAndModel',
  NewestYear = 'NewestYear',
  LowestMileage = 'LowestMileage'
}

export default SortOption;
